import React, { FocusEvent, ChangeEvent, useCallback, useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios, { AxiosError } from "axios";

import { tceppsActions } from "../../redux-store/reducer/tcepps_slice";
import PaymentService from "../../service/paymentService";
import { LogService, LOGINFOLEVEL, LOGERRORLEVEL } from "../../service/logService";
import { decryptParamType } from "../../utils/calendarUtil";
import { TceppsTestData, isTestingApp } from "../../utils/TestLoadData";
import { setAppName } from "../../utils/consoleLog";
import { getStringify } from "../../utils/utils";
import s21csamycsaach from "./S21CsaMycsaAch.module.css"; // provided by S21CSA_MYCSA team
// Import Bootstrap 3 CSS here

const Buffer = require("buffer/").Buffer; // note: the trailing slash is important!

// let developmentEnv = false;
const dialogTimeoutInMins = 3; // 3 minutes

const appTokenName = "appToken";

const ECPCHECKRTLENGTH = "Must contain exactly 9 numbers\n";
const ECPCHECKDDACONFIRMMISMATCH = "Account numbers do not match";
const REENTERBANKCODE = "Copy/Paste not allowed.";
// const FIELDISREQUIRED = "Required";
const ACCOUTNUMBERREQUIRED = "Please enter Account Number.";
const REEMTERACCOUTNUMBERREQUIRED = "Please enter Account Number.";
const ROUTINGNUMBERREQUIRED = "Please enter Routing Number.";
const PHONENUMBERREQUIRED = "Please enter Phone Number.";
const PHONELENGTHMESSAGE = "Phone must be 10 digits";

const INVALIDAXIOSMESSAGE = "AxiosError. ";

export function S21CsaMycsaAchComponent(this: any) {
  const dispatch = useDispatch();
  const tceppsState = useSelector((state: any) => state.tcepps);

  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [ecpCheckDDAMsg, setEcpCheckDDAMsg] = useState("");
  const [ecpCheckDDAConfirmMsg, setEcpCheckDDAConfirmMsg] = useState("");
  const [ecpCheckRTMsg, setEcpCheckRTMsg] = useState("");
  const [avsPhoneMsg, setAvsPhoneMsg] = useState("");
  // const [tceppsCancelUrl, setTceppsCancelUrl] = useState("");
  const [batchNumber, setBatchNumber] = useState("");
  const [ecpCheckRT, setEcpCheckRT] = useState("");
  const [ecpCheckDDA, setEcpCheckDDA] = useState("");
  const [avsPhone, setAvsPhone] = useState("");
  const [ecpCheckDDAConfirm, setEcpCheckDDAConfirm] = useState("");
  const [agreementCheck, setAgreementCheck] = useState(false);
  const [durationMessage, setDurationMessage] = useState("");
  const [sessionTimeoutMins, setSessionTimeoutMins] = useState("0");
  const [processing, setProcessing] = useState(false);

  const [ecpCheckRTDisabled, setEcpCheckRTDisabled] = useState(false);
  const [ecpCheckDDADisabled, setEcpCheckDDADisabled] = useState(false);
  const [ecpCheckDDAConfirmDisabled, setEcpCheckDDAConfirmDisabled] = useState(false);
  const [agreementCheckDisabled, setAgreementCheckDisabled] = useState(false);
  const [avsPhoneDisabled, setAvsPhoneDisabled] = useState(false);

  const ecpCheckRTRef = useRef<HTMLInputElement>(null);
  const ecpCheckDDARef = useRef<HTMLInputElement>(null);
  const ecpCheckDDAConfirmRef = useRef<HTMLInputElement>(null);
  const avsPhoneRef = useRef<HTMLInputElement>(null);
  const agreementCheckRef = useRef<HTMLInputElement>(null);
  const processingFormRef = useRef<boolean>(false);
  const formatedAmountRef = useRef<String>("");
  const formSubmittedRef = useRef<boolean>(false);

  // We need ref in this, because we are dealing
  // with JS setInterval to keep track of it and
  // stop it when needed
  const countDownRef = useRef(-1);
  const durationMessageRef = useRef(-1);
  const sessionTimeoutRef = useRef(-1);

  // const [processingForm, setProcessingForm] = useState(false);
  const [submitButtonEnable, setSubmitButtonEnable] = useState(false);
  const [clickSubmit, setClickSubmit] = useState(false);

  const confirmCancelDialog = document.getElementById("confirmCancelDialog") as HTMLDialogElement;

  const [decryptParams, setDecryptParams] = useState([] as decryptParamType);

  const { appKey } = useParams();

  const logBatchIdRef = useRef<string>("CPNET ACH Not initialized");

  // Close the transaction processing dialog
  const openConfirmCancelDialog = () => {
    if (confirmCancelDialog) confirmCancelDialog.showModal();
  };
  const closeConfirmCancelDialog = () => {
    if (confirmCancelDialog) confirmCancelDialog.close();
  };

  useEffect(() => {
    setAppName("S21CSAMYCSAACH");
    return () => {
      try {
        if (countDownRef.current && countDownRef.current !== -1) clearInterval(countDownRef.current);
      } catch (exception) {}
      try {
        if (durationMessageRef.current && durationMessageRef.current !== -1) clearInterval(durationMessageRef.current);
      } catch (exception) {}
      try {
        if (sessionTimeoutRef.current && sessionTimeoutRef.current !== -1) clearInterval(sessionTimeoutRef.current);
      } catch (exception) {}
    };
  }, []);

  const closeDialog = useCallback(() => {
    // Always destroy the countdown timer object when the dialog is closed
    if (countDownRef.current && countDownRef.current !== -1) clearInterval(countDownRef.current);
    // $("#durationMessage").countdown("destroy");

    return false;
  }, []);

  const expiredDuration = () => {
    closeDialog();
    // $("#errorMessages").text("Order was not processed. Please resubmit");
    setErrorMessage("Order was not processed. Please resubmit");
    setShowErrorMessage(true);
  };

  /*
   ** Countdown timer related code START
   */
  const getTimeRemaining = (e: Date) => {
    return e.getTime() - new Date().getTime();
  };

  const startTimer = (e: Date) => {
    let totalTimeLeft = getTimeRemaining(e);
    if (totalTimeLeft < 0) {
      // do action
      expiredDuration();
    }
  };

  const initiateTimerForClosingTransactionProcessingDialog = (e: Date) => {
    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (countDownRef.current && countDownRef.current !== -1) clearInterval(countDownRef.current);
    const id = window.setInterval(() => {
      startTimer(e);
    }, 1000);
    countDownRef.current = id;
  };

  const getDeadTime = () => {
    let deadline = new Date();

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setMinutes(deadline.getMinutes() + dialogTimeoutInMins);
    return deadline;
  };

  /*
   ** DurationMessage Time work START
   */
  // Format duration with 2 digits and correct suffix
  const formatTwoDigits = (value: number) => {
    return (value < 10 ? "0" : "") + "" + value;
  };

  const formatDuration = useCallback((min: number, sec: number) => {
    // Always display 2 digits
    let minStr = formatTwoDigits(min);
    let secStr = formatTwoDigits(sec);

    // i.e. 01:45
    let duration = minStr + ":" + secStr;

    if (min > 0) {
      duration = duration + " minutes ";
    } else {
      duration = duration + " seconds ";
    }

    return duration;
  }, []);

  const getDurationMessageTimeRemaining = (e: Date) => {
    const totalTimeLeft = e.getTime() - new Date().getTime();
    const seconds = Math.floor((totalTimeLeft / 1000) % 60);
    const minutes = Math.floor((totalTimeLeft / 1000 / 60) % 60);
    // const hours = Math.floor((totalTimeLeft / 1000 / 60 / 60) % 24);
    return {
      totalTimeLeft,
      // hours,
      minutes,
      seconds,
    };
  };

  const pauseCountdown = () => {
    if (durationMessageRef.current && durationMessageRef.current !== -1) clearInterval(durationMessageRef.current);
  };

  const startDurationMessageTimer = useCallback(
    (e: Date) => {
      let { totalTimeLeft, minutes, seconds } = getDurationMessageTimeRemaining(e);
      if (totalTimeLeft < 0) {
        // do action
        enableOrDisableInput("submitTransaction", true);
        setDurationMessage("Your session timed out for security. Please close to try again.");
      } else {
        setDurationMessage("Please complete your payment within " + formatDuration(minutes, seconds) + "to prevent session timeout.");
      }
    },
    [formatDuration],
  );

  const initiateDurationMessageTimer = useCallback(() => {
    let deadline = new Date();
    // Countdown timer at 5 mins and session timeout. Minus 2 seconds to compensate for page load time
    const durationMessageInMins = 4; // 4 minutes
    const durationMessageInSecs = 59; // 59 sec minutes
    deadline.setMinutes(deadline.getMinutes() + durationMessageInMins);
    deadline.setSeconds(deadline.getSeconds() + durationMessageInSecs);

    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (durationMessageRef.current && durationMessageRef.current !== -1) clearInterval(durationMessageRef.current);
    const id = window.setInterval(() => {
      startDurationMessageTimer(deadline);
    }, 1000);
    durationMessageRef.current = id;
  }, [startDurationMessageTimer]);

  /*
   ** DurationMessage Time work END
   */

  /*
   ** Session Timeout work START
   */
  // Format duration with 2 digits and correct suffix
  const getSessionTimeoutTimeRemaining = (e: Date) => {
    return e.getTime() - new Date().getTime();
  };

  const startSessionTimeoutTimer = useCallback((e: Date) => {
    let totalTimeLeft = getSessionTimeoutTimeRemaining(e);
    if (totalTimeLeft < 0) {
      // do action
      // Automatically save the order if the session times out
      // saveModifyOrder(document.getElementById("ach"));
    }
  }, []);

  const initiateSessionTimeoutTimer = useCallback(() => {
    let origDate = new Date();
    let deadline = new Date(origDate);
    deadline.setMinutes(origDate.getMinutes() + Number(sessionTimeoutMins));
    if (Number(sessionTimeoutMins) > 0) {
      if (sessionTimeoutRef.current && sessionTimeoutRef.current !== -1)
        // If you try to remove this line the
        // updating of timer Variable will be
        // after 1000ms or 1sec
        clearInterval(sessionTimeoutRef.current);
      const id = window.setInterval(() => {
        startSessionTimeoutTimer(deadline);
      }, 1000);
      sessionTimeoutRef.current = id;
    }
  }, [sessionTimeoutMins, startSessionTimeoutTimer]);

  /*
   ** Session Timeout work END
   */

  /*
   ** Countdown timer related code END
   */
  // Remove all characters ($,) except digits and decimal point

  const enableOrDisableInput = (fieldName: string, disabledValue: boolean) => {
    switch (fieldName) {
      case "cancel":
        setClickSubmit(!disabledValue);
        break;
      case "submitTransaction":
        setSubmitButtonEnable(!disabledValue);
        break;
    }
  };

  const agreementClick = () => {
    if (agreementCheckRef.current?.checked) {
      if (durationMessage.indexOf("expired") <= 0) {
        enableOrDisableInput("submitTransaction", false);
      }
    } else {
      enableOrDisableInput("submitTransaction", true);
    }
  };

  const checkForm = useCallback(() => {
    let setFocusSet = false;

    if (decryptParams && Object.keys(decryptParams).length > 0 && !processingFormRef.current) {
      if (ecpCheckDDA.trim() === "") {
        setEcpCheckDDAMsg(ACCOUTNUMBERREQUIRED);
        if (!setFocusSet) ecpCheckDDARef.current?.focus();
        setFocusSet = true;
      } else {
        setEcpCheckDDAMsg("");
      }

      if (ecpCheckDDAConfirm.trim() === "") {
        setEcpCheckDDAConfirmMsg(REEMTERACCOUTNUMBERREQUIRED);
        if (!setFocusSet) ecpCheckDDAConfirmRef.current?.focus();
        setFocusSet = true;
      } else if (ecpCheckDDA.trim() !== "" && ecpCheckDDAConfirm.trim() !== ecpCheckDDA.trim()) {
        setEcpCheckDDAConfirmMsg(ECPCHECKDDACONFIRMMISMATCH);
        if (!setFocusSet) ecpCheckDDAConfirmRef.current?.focus();
        setFocusSet = true;
      } else {
        setEcpCheckDDAConfirmMsg("");
      }

      if (ecpCheckRT.trim() === "") {
        setEcpCheckRTMsg(ROUTINGNUMBERREQUIRED);
        if (!setFocusSet) ecpCheckRTRef.current?.focus();
        setFocusSet = true;
      } else if (ecpCheckRT.trim().length !== 9) {
        setEcpCheckRTMsg(ECPCHECKRTLENGTH);
        if (!setFocusSet) ecpCheckRTRef.current?.focus();
        setFocusSet = true;
      } else {
        setEcpCheckRTMsg("");
      }

      if (avsPhone.trim() === "") {
        setAvsPhoneMsg(PHONENUMBERREQUIRED);
        if (!setFocusSet) avsPhoneRef.current?.focus();
        setFocusSet = true;
      } else if (avsPhone.trim().replace(/[^0-9]/g, "").length !== 10) {
        setAvsPhoneMsg(PHONELENGTHMESSAGE);
        if (!setFocusSet) avsPhoneRef.current?.focus();
        setFocusSet = true;
      } else {
        setAvsPhoneMsg("");
      }

      if (!setFocusSet) {
        return true;
      } else {
        processingFormRef.current = false;
        // Close the transaction processing dialog for all error conditions
        closeDialog();
        return false;
      }
    }
  }, [decryptParams, closeDialog, ecpCheckDDA, ecpCheckDDAConfirm, ecpCheckRT, avsPhone]);

  const clearMessages = () => {
    setShowErrorMessage(false);
    setErrorMessage("");
    setDurationMessage("");
  };

  // const clearForm = (ach: any) => {
  //   setEcpCheckDDA("");
  //   setEcpCheckDDAConfirm("");
  //   setEcpCheckRT("");
  //   setAvsPhone("");
  //   pauseCountdown();
  //   clearMessages();
  // };

  const toggleFields = useCallback((addProfile: string) => {
    const disabled = addProfile === "true" ? false : true;

    setEcpCheckRTDisabled(disabled);
    setEcpCheckDDADisabled(disabled);
    setEcpCheckDDAConfirmDisabled(disabled);
    setAvsPhoneDisabled(disabled);
    setAgreementCheckDisabled(disabled);
    setClickSubmit(disabled);
  }, []);

  const decodeURIBill = (str: string) => {
    // This function decodes a URI by treating each escape sequence in the form %XX
    // as one UTF-8 code unit (one byte). In UTF-8, the number of leading 1 bits in the first byte,
    // which may be 0 (for 1-byte ASCII characters), 2, 3, or 4, indicates the number of bytes in the character.

    return decodeURIComponent(str.replace(/\+/g, " "));
  };

  const invokeNewOrder = useCallback(
    async (pno: any, tcepps: any, ach: any) => {
      if (!processingFormRef.current) {
        // setProcessingForm(true);
        processingFormRef.current = true;
        setProcessing(true);

        // Executing a newOrder disables all buttons because the control is handed back to ACH. In the event that the control cannot
        // be handed back to ACH (unknown exception or network error), the user is not allowed to click any buttons which will avoid
        // duplicate payment issues
        enableOrDisableInput("submitTransaction", true);
        enableOrDisableInput("cancel", true);

        let email = decryptParams["email"];
        let avsAddress1 = decryptParams["pno.avsAddress1"];
        let avsAddress2 = decryptParams["pno.avsAddress2"];
        let avsCity = decryptParams["pno.avsCity"];
        let avsState = decryptParams["pno.avsState"];
        let avsZip = decryptParams["pno.avsZip"];
        let avsCountryCode = decryptParams["pno.avsCountryCode"];
        let email1 = decryptParams["pno.customerEmail"];
        let priorAuthCd = decryptParams["pno.priorAuthCd"];
        if (!(email && email.length > 0)) {
          email = email1;
        }
        if (!(email && email.length > 0)) {
          // email = DEFUSEREMAIL;
        }
        if (avsAddress1 && avsAddress1.length > 0) {
          avsAddress1 = decodeURIBill(avsAddress1);
        }
        if (avsAddress2 && avsAddress2.length > 0) {
          avsAddress2 = decodeURIBill(avsAddress2);
        }
        let orbitalConnectionUsername = decryptParams["pno.orbitalConnectionUsername"];
        let orbitalConnectionPassword = decryptParams["pno.orbitalConnectionPassword"];
        let switchSoloIssueNum = decryptParams["pno.switchSoloIssueNum"];
        let switchSoloCardStartDate = decryptParams["pno.switchSoloCardStartDate"];
        let authenticationECIInd = decryptParams["pno.authenticationECIInd"];
        if (!orbitalConnectionUsername) {
          orbitalConnectionUsername = decryptParams["orbitalConnectionUsername"];
        }
        if (!orbitalConnectionPassword) {
          orbitalConnectionPassword = decryptParams["orbitalConnectionPassword"];
        }
        if (!switchSoloIssueNum) {
          switchSoloIssueNum = decryptParams["switchSoloIssueNum"];
        }
        if (!switchSoloCardStartDate) {
          switchSoloCardStartDate = decryptParams["switchSoloCardStartDate"];
        }
        if (!authenticationECIInd) {
          authenticationECIInd = decryptParams["authenticationECIInd"];
        }
        pno.orbitalConnectionUsername.value = orbitalConnectionUsername ? orbitalConnectionUsername : "";
        pno.orbitalConnectionPassword.value = orbitalConnectionPassword ? orbitalConnectionPassword : "";
        pno.switchSoloIssueNum.value = switchSoloIssueNum ? switchSoloIssueNum : "";
        pno.switchSoloCardStartDate.value = switchSoloCardStartDate ? switchSoloCardStartDate : "";
        pno.authenticationECIInd.value = authenticationECIInd ? authenticationECIInd : "";

        // let batchNumber = decryptParams["app.batchNo"];
        let billToNameVar = decryptParams["app.billToName"];
        if (billToNameVar && billToNameVar.length > 0) {
          billToNameVar = decodeURIBill(billToNameVar);
        }
        let tceppsCancelUrlVar = decryptParams["tcepps.cancelUrl"];
        let tceppsSuccessUrlVar = decryptParams["tcepps.successUrl"];

        pno.avsName.value = billToNameVar != null && billToNameVar.trim() != null ? billToNameVar.trim().toUpperCase() : "";
        pno.avsAddress1.value = avsAddress1 != null && avsAddress1.trim() != null ? avsAddress1.trim().toUpperCase() : "";
        pno.avsAddress2.value = avsAddress2 != null && avsAddress2.trim() != null ? avsAddress2.trim().toUpperCase() : "";
        pno.avsCity.value = avsCity != null && avsCity.trim() != null ? avsCity.trim().toUpperCase() : "";
        pno.avsState.value = avsState != null && avsState.trim() != null ? avsState.trim().toUpperCase() : "";
        pno.avsZip.value = avsZip != null && avsZip.trim() != null ? avsZip.trim().toUpperCase() : "";
        pno.avsCountryCode.value = avsCountryCode != null && avsCountryCode.trim() != null ? avsCountryCode.trim().toUpperCase() : "";
        pno.avsPhone.value =
          avsPhone != null && avsPhone.trim().replace(/[^0-9]/g, "") != null ? avsPhone.trim().replace(/[^0-9]/g, "") : "";
        pno.ecpCheckRT.value =
          ecpCheckRTRef.current?.value && ecpCheckRTRef.current?.value.trim() != null ? ecpCheckRTRef.current?.value.trim() : "";
        pno.ecpCheckDDA.value =
          ecpCheckDDARef.current?.value && ecpCheckDDARef.current.value.trim() != null ? ecpCheckDDARef.current.value.trim() : "";
        pno.ecpBankAcctType.value = "X";
        pno.orderID.value = batchNumber != null && batchNumber.trim() != null ? batchNumber.trim() : "";
        pno.retryTrace.value = batchNumber != null && batchNumber.trim() != null ? batchNumber.trim() : "";
        pno.priorAuthCd.value = priorAuthCd != null && priorAuthCd.trim() != null ? priorAuthCd.trim() : "";
        pno.merchantID.value = decryptParams["pno.merchantID"];
        // Paying total amount due
        pno.amount.value = formatedAmountRef.current ? formatedAmountRef.current.replace("$", "") : "0.00";
        pno.customerEmail.value = email ? email.trim() : "";
        tcepps.serviceOperation.value = "newOrder";
        tcepps.successUrl.value = tceppsSuccessUrlVar !== null ? tceppsSuccessUrlVar : "";
        tcepps.cancelUrl.value = tceppsCancelUrlVar !== null ? tceppsCancelUrlVar : "";
        tcepps.app.value = tceppsState.app != null && tceppsState.app.toUpperCase().trim() ? tceppsState.app.toUpperCase().trim() : "";
        tcepps.token.value = tceppsState.token != null ? tceppsState.token : "";
        tcepps.sign.value = tceppsState.sign != null ? tceppsState.sign : "";

        toggleFields("false");
        // Cannot clear the form because the values are needed for sending back
        //clearForm();
        pauseCountdown();
        clearMessages();
        const myCsaAchObj = {
          "pno.avsName": pno.avsName.value,
          "pno.avsAddress1": pno.avsAddress1.value,
          "pno.avsAddress2": pno.avsAddress2.value,
          "pno.avsCity": pno.avsCity.value,
          "pno.avsState": pno.avsState.value,
          "pno.avsZip": pno.avsZip.value,
          "pno.avsPhone": pno.avsPhone.value,
          "pno.ecpCheckRT": pno.ecpCheckRT.value,
          "pno.ecpCheckDDA": pno.ecpCheckDDA.value,
          "pno.ecpBankAcctType": pno.ecpBankAcctType.value,
          "pno.retryTrace": pno.retryTrace.value,
          "pno.priorAuthCd": pno.priorAuthCd.value,
          //"pno.merchantID": pno.merchantID.value,
          "pno.amount": pno.amount.value,
          "pno.orderID": pno.orderID.value,
          "pno.avsCountryCode": pno.avsCountryCode.value,
          "pno.customerEmail": pno.customerEmail.value,
          // "tcepps.proxyUrl": proxyUrl,
          "tcepps.serviceOperation": tcepps.serviceOperation.value,
          "tcepps.successUrl": tcepps.successUrl.value,
          "tcepps.cancelUrl": tcepps.cancelUrl.value,
          "tcepps.app": tcepps.app.value,
          "tcepps.token": tcepps.token.value,
          "tcepps.sign": tcepps.sign.value,
        };
        LogService.logMessage(logBatchIdRef.current, LOGINFOLEVEL, "calling newOrder1");

        PaymentService.submitS21csamycsach(myCsaAchObj)
          .then((resp: any) => {
            window.parent.postMessage({ type: "transactionResponse", payload: resp.data }, "*");
          })
          .catch((err: Error | AxiosError) => {
            // console.log(err);
            if (axios.isAxiosError(err)) {
              // Access to config, request, and response
              setErrorMessage(INVALIDAXIOSMESSAGE + "call to submitMycanonSnr failed. " + err.message + ". Please check console..");
            } else {
              // Just a stock error
              setErrorMessage("Error in submitMycanonSnr. " + err.message + ". Please check console..");
            }
            // isBackgroundRed = true;
            LogService.logMessage(
              logBatchIdRef.current,
              LOGERRORLEVEL,
              "Call to CpgmuiService.submitServiceOperationRest failed:" + (err ? getStringify(err.message) : "null"),
            );
            closeDialog();
            setErrorMessage("Call to CpgmuiService.submitServiceOperationRest failed. " + err.message);
            setShowErrorMessage(true);
            // setProcessingForm(false);
            processingFormRef.current = false;
            setProcessing(false);
          });
      }
    },
    [toggleFields, tceppsState.app, tceppsState.token, tceppsState.sign, decryptParams, avsPhone, batchNumber, closeDialog],
  );

  // Open the transaction processing dialog
  const openDialog = () => {
    // If the dialog stays open for a certain amount of time, close it because it means an exception happened and user will then
    // be able to re-submit if it's within the token expiration timeframe
    initiateTimerForClosingTransactionProcessingDialog(getDeadTime());

    setErrorMessage("");
    return false;
  };

  const processTransaction = () => {
    // disableOnBeforeUnload();
    openDialog();
    invokeNewOrder(document.getElementById("pno"), document.getElementById("tcepps"), document.getElementById("ach"));
    // Cannot clear the form because the values are needed for sending back
    pauseCountdown();
    clearMessages();
  };

  // const invokeCancel = (ach: any) => {
  //   ach.action = tceppsCancelUrl + "?achPayment.txBatchNo=" + batchNumber;
  //   ach.submit();
  // };

  const cancelOrder = () => {
    // closeConfirmCancelDialog();
    // clearForm(document.getElementById("ach"));
    // invokeCancel(document.getElementById("ach"));
    setEcpCheckDDA("");
    setEcpCheckDDAConfirm("");
    setEcpCheckRT("");
    setAvsPhone("");
    setEcpCheckDDAMsg("");
    setEcpCheckDDAConfirmMsg("");
    setEcpCheckRTMsg("");
    setAvsPhoneMsg("");
    setShowErrorMessage(false);
    setErrorMessage("");
    if (confirmCancelDialog) confirmCancelDialog.close();
  };

  const tceppsResponseErrorUiCopyPaste = (event: any) => {
    setEcpCheckDDAConfirmMsg(REENTERBANKCODE);
    event.preventDefault();
    event.stopPropagation();
  };

  const onKeyDownHandler = () => {
    if (ecpCheckDDAConfirmMsg === REENTERBANKCODE) {
      setEcpCheckDDAConfirmMsg("");
    }
  };

  const placeOrder = () => {
    LogService.logMessage(logBatchIdRef.current, LOGINFOLEVEL, "placeOrder");
    if (checkForm()) {
      LogService.logMessage(logBatchIdRef.current, LOGINFOLEVEL, "processTransaction..1");
      processTransaction();
    } else {
      LogService.logMessage(logBatchIdRef.current, LOGINFOLEVEL, "placeOrder..validation error");
    }
  };

  // When Submit button is clicked
  const onClickHandler = (event: any) => {
    LogService.logMessage(logBatchIdRef.current, LOGINFOLEVEL, "User Clicked id:" + event.target.id + " value:" + event.target.value);
    switch (event.target.value) {
      case "Clear":
        // event.preventDefault();
        // disableOnBeforeUnload();
        openConfirmCancelDialog();
        // cancelOrder();
        break;
      case "Submit Payment":
        event.preventDefault();
        formSubmittedRef.current = true;
        if (!processingFormRef.current) {
          // Open the transaction processing dialog
          placeOrder();
        }
        break;
      case "Yes":
        if (event.target.id === "cancelOrder") {
          LogService.logMessage(logBatchIdRef.current, LOGINFOLEVEL, "User Clicked cancelOrder.");
          cancelOrder();
        }
        break;
      case "No":
        if (event.target.id === "closeConfirmCancel") {
          closeConfirmCancelDialog();
        }
        break;
    }
  };

  useEffect(() => {
    try {
      // 1. Target the actual HTML <body> element
      const bodyEl = (document.querySelector("#root") as HTMLDivElement).parentElement as HTMLBodyElement;
      bodyEl.style.margin = "0";
      bodyEl.style.overflowY = "hidden"; // Hides vertical scrollbar on body

      // 2. Target the actual HTML <html> element just in case
      const htmlEl = bodyEl.parentElement;
      if (htmlEl) {
        htmlEl.style.overflowY = "hidden"; // Hides vertical scrollbar on html
      }
    } catch (exception) {}

    // start displaying durationMessage countdown
    initiateDurationMessageTimer();
    initiateSessionTimeoutTimer();

    // 3. Clean up and restore scrolling if the user ever leaves this page
    return () => {
      try {
        const bodyEl = (document.querySelector("#root") as HTMLDivElement).parentElement as HTMLBodyElement;
        bodyEl.style.overflowY = "auto";
        const htmlEl = bodyEl.parentElement;
        if (htmlEl) {
          htmlEl.style.overflowY = "auto";
        }
      } catch (exception) {}
    };
  }, [initiateDurationMessageTimer, initiateSessionTimeoutTimer]);

  const extractPhoneNumber = (onlyNumbers: string) => {
    // Slice the string into chunks
    const part1 = onlyNumbers.substring(0, 3);
    const part2 = onlyNumbers.substring(3, 6);
    const part3 = onlyNumbers.substring(6, 10);
    if (onlyNumbers.length > 6) {
      return `${part1}-${part2}-${part3}`;
    } else if (onlyNumbers.length > 3) {
      return `${part1}-${part2}`;
    } else {
      return part1;
    }
  };

  // useEffect if screen/page input parameters change. Dispatch state change
  useEffect(() => {
    // console.log("useEffect initialload...4");

    const appKey0 = Buffer.from(appKey ? appKey : "", "base64");
    const appKey1 = appKey0.toString("utf8");
    const mydata = JSON.parse(appKey1);

    let requestParameter = {
      app: "",
      token: "",
      sign: "",
      serviceOperation: "",
      encryptedRequest: "",
      encryptedRequestKey: "",
      enableNewCrCardFlag: "",
      addProfile: "",
      cpgmuiApiUrl: "",
      cpgmuiEnv: "",
      session_timeoutinmins: "",
    };

    const getPortNumber = () => {
      const windowsUrl = window.location.href;
      const searchParams = windowsUrl.indexOf("//") + 2;
      const firstSlashIndex = windowsUrl.indexOf("/", searchParams);
      const colonIndex = windowsUrl.indexOf(":", searchParams);
      if (firstSlashIndex > 0 && colonIndex > 0) {
        return windowsUrl.substring(colonIndex + 1, firstSlashIndex);
      } else {
        return "";
      }
    };

    //find port if it exits
    const urlPortNumber = getPortNumber();

    Object.keys(mydata).forEach((key) => {
      switch (key) {
        case "tcepps.app":
          requestParameter.app = mydata[key];
          break;
        case "tcepps.token":
          requestParameter.token = mydata[key];
          break;
        case "tcepps.sign":
          requestParameter.sign = mydata[key];
          break;
        case "tcepps.serviceOperation":
          requestParameter.serviceOperation = mydata[key];
          break;
        case "tcepps.encryptedRequest":
          requestParameter.encryptedRequest = mydata[key];
          break;
        case "tcepps.encryptedRequestKey":
          requestParameter.encryptedRequestKey = mydata[key];
          break;
        case "tcepps.enableNewCrCardFlag":
          requestParameter.enableNewCrCardFlag = mydata[key];
          break;
        case "tcepps.addProfile":
          requestParameter.addProfile = mydata[key];
          break;
        case "cpgmuiApiUrl":
          requestParameter.cpgmuiApiUrl = mydata[key] + "/TCEPPS/jsp/tceppsHtmlFormInterface.jsp?tceppsApp=";
          if (urlPortNumber !== "") {
            let backendPortNumber = getPortNumber();
            if (backendPortNumber !== urlPortNumber) {
              requestParameter.cpgmuiApiUrl = requestParameter.cpgmuiApiUrl.replace(backendPortNumber, urlPortNumber);
            }
          }
          break;
        case "cpgmuiEnv":
          requestParameter.cpgmuiEnv = mydata[key];
          // if (requestParameter.cpgmuiEnv.toLowerCase() === "development") {
          //   developmentEnv = true;
          // }
          break;
        case "ACH_SESSION_TIMEOUTINMINS":
          if (mydata[key] && mydata[key].trim().length > 0) setSessionTimeoutMins(mydata[key].trim());
          break;
      }
    });
    requestParameter.cpgmuiApiUrl += requestParameter.app;

    dispatch(
      tceppsActions.initializeTceppsAction({
        app: requestParameter.app,
        token: requestParameter.token,
        sign: requestParameter.sign,
        serviceOperation: requestParameter.serviceOperation,
        encryptedRequest: requestParameter.encryptedRequest,
        encryptedRequestKey: requestParameter.encryptedRequestKey,
        enableNewCrCardFlag: requestParameter.enableNewCrCardFlag,
        cpgmuiApiUrl: requestParameter.cpgmuiApiUrl,
        cpgmuiEnv: requestParameter.cpgmuiEnv,
      }),
    );

    // decrypt the input parameters
    const decryptInputParameterAsync = async (app: string, encryptedRequestKey: string, encryptedRequest: string) => {
      let decryptParamsResponse: any;

      try {
        const response = await PaymentService.getDecryptRequest(app, encryptedRequestKey, encryptedRequest);
        decryptParamsResponse = response.data;
      } catch (err: any) {
        // console.log(err);
        if (axios.isAxiosError(err)) {
          // Access to config, request, and response
          setErrorMessage(INVALIDAXIOSMESSAGE + "call to getDecryptRequest failed. " + err.message + ". Please check console..");
          setShowErrorMessage(true);
        } else {
          // Just a stock error
          setErrorMessage("Error in getDecryptRequest. " + err.message + ". Please check console..");
          setShowErrorMessage(true);
        }
        // isBackgroundRed = true;
        LogService.logMessage(logBatchIdRef.current, LOGERRORLEVEL, "Call to getDecryptRequest failed.");
      }

      if (decryptParamsResponse && Object.keys(decryptParamsResponse).length > 0) {
        setDecryptParams(decryptParamsResponse);
        // console.log(Object.keys(decryptParamsResponse));
        let amount = decryptParamsResponse["amount"];
        try {
          if (amount && amount.length < 1) {
            amount = "000";
          }
          if (amount && amount.length < 2) {
            amount = "00" + amount;
          }
          if (amount && amount.length === 2) {
            amount = "0" + amount;
          }
          amount = amount.substring(0, amount.length - 2) + "." + amount.substring(amount.length - 2);
        } catch (Exception) {
          console.log(Exception);
        }
        // setTransactionAmount(amount);
        formatedAmountRef.current = "$" + amount; //formatAsCurrency(amount);
        // const tceppsSuccessUrl = decryptParamsResponse["tcepps.successUrl"];
        // const tceppsCancelUrl = decryptParamsResponse["tcepps.cancelUrl"];
        // const tceppsUpdateSubmitUrl = decryptParamsResponse["tcepps.updateSubmitUrl"];
        const batchNumber = decryptParamsResponse["app.batchNo"];
        logBatchIdRef.current = "MYCSA_ACH " + batchNumber;
        // setTceppsSuccessUrl(tceppsSuccessUrl ? tceppsSuccessUrl.trim() : "");
        // setTceppsCancelUrl(tceppsCancelUrl ? tceppsCancelUrl.trim() : "");
        // setTceppsUpdateSubmitUrl(tceppsUpdateSubmitUrl ? tceppsUpdateSubmitUrl.trim() : "");
        setBatchNumber(batchNumber ? batchNumber.trim() : "");

        const avsPhone = decryptParamsResponse["pno.avsPhone"];
        if (avsPhone) {
          const onlyNumbers = avsPhone.replace(/[^0-9]/g, "");
          setAvsPhone(extractPhoneNumber(onlyNumbers));
        }

        if (isTestingApp(decryptParamsResponse["app.TESTINGAPP"])) {
          // check if its called from testing app
          // developmentEnv = true;
          const ecpCheckRT = decryptParamsResponse["pno.ecpCheckRT"];
          if (ecpCheckRT) {
            setEcpCheckRT(ecpCheckRT);
          } else {
            setEcpCheckRT(TceppsTestData.ToBeAppTestData.S21CSAMYCSA_ACH["to_be_app.routingNumber"]);
          }
          const ecpCheckDDA = decryptParamsResponse["pno.ecpCheckDDA"];
          if (ecpCheckDDA) {
            setEcpCheckDDA(ecpCheckDDA);
          } else {
            setEcpCheckDDA(TceppsTestData.ToBeAppTestData.S21CSAMYCSA_ACH["to_be_app.bankAccountNumber"]);
          }
          // setEcpCheckDDAConfirm(TceppsTestData.ToBeAppTestData.CPNET_ACH["to_be_app.bankAccountNumber"]);
        } else {
          setEcpCheckRT("");
          setEcpCheckDDA("");
          setEcpCheckDDAConfirm("");
        }

        return true;
      } else {
        setErrorMessage("Customer details not available. Please close and retry.");
        setShowErrorMessage(true);
        LogService.logMessage(logBatchIdRef.current, LOGERRORLEVEL, "Customer details not available. Please close and retry.");
        return;
      }
    };

    decryptInputParameterAsync(
      requestParameter.app.toUpperCase().trim(),
      requestParameter.encryptedRequestKey,
      requestParameter.encryptedRequest,
    );

    if (confirmCancelDialog) confirmCancelDialog.close();
  }, [appKey, dispatch, confirmCancelDialog]);

  const onChangeHandler = (identifier: string, event: ChangeEvent & { target: HTMLInputElement | HTMLTextAreaElement }) => {
    let onlyNumbers = "";
    switch (identifier) {
      case "ecpCheckRT":
        // Replace any character that is NOT a digit (0-9) with an empty string
        onlyNumbers = event.target.value.replace(/[^0-9]/g, "");
        setEcpCheckRT(onlyNumbers);
        break;
      case "ecpCheckDDA":
        // Replace any character that is NOT a digit (0-9) with an empty string
        onlyNumbers = event.target.value.replace(/[^0-9]/g, "");
        setEcpCheckDDA(onlyNumbers);
        break;
      case "ecpCheckDDAConfirm":
        // Replace any character that is NOT a digit (0-9) with an empty string
        onlyNumbers = event.target.value.replace(/[^0-9]/g, "");
        setEcpCheckDDAConfirm(onlyNumbers);
        break;
      case "avsPhone":
        // Replace any character that is NOT a digit (0-9) with an empty string
        onlyNumbers = event.target.value.replace(/[^0-9]/g, "");
        setAvsPhone(extractPhoneNumber(onlyNumbers));
        break;
      case "agreement":
        setAgreementCheck(agreementCheckRef.current?.checked as any);
        agreementClick();
        break;
    }
  };

  const onBlurHandler = (identifier: string, event: FocusEvent & { target: HTMLInputElement | HTMLTextAreaElement }) => {
    switch (identifier) {
      case "ecpCheckRT":
        setEcpCheckRT(event.target.value);
        if (event.target.value !== "" && ecpCheckRTMsg !== "") {
          setEcpCheckRTMsg("");
        }
        break;
      case "ecpCheckDDA":
        setEcpCheckDDA(event.target.value);
        if (event.target.value !== "" && ecpCheckDDAMsg !== "") {
          setEcpCheckDDAMsg("");
        }
        break;
      case "ecpCheckDDAConfirm":
        setEcpCheckDDAConfirm(event.target.value);
        if (event.target.value !== "" && ecpCheckDDAConfirmMsg !== "") {
          setEcpCheckDDAConfirmMsg("");
        }
        break;
      case "avsPhone":
        setAvsPhone(event.target.value);
        if (event.target.value !== "" && avsPhoneMsg !== "") {
          setAvsPhoneMsg("");
        }
        break;
    }
  };

  return (
    <>
      <form id="tcepps" name="tcepps" action={tceppsState.cpgmuiApiUrl} target="_self">
        <input id="app" name="app" type="hidden" value={tceppsState.app} />
        <input id="token" name="token" type="hidden" value={tceppsState.token} />
        <input id="sign" name="sign" type="hidden" value={tceppsState.sign} />
        <input id="serviceOperation" name="serviceOperation" type="hidden" value="" />
        <input id="encryptedRequest" name="encryptedRequest" type="hidden" value={tceppsState.encryptedRequest} />
        <input id="encryptedRequestKey" name="encryptedRequestKey" type="hidden" value={tceppsState.encryptedRequestKey} />
        <input id="proxyUrl" name="proxyUrl" type="hidden" value="" />
        <input id="successUrl" name="successUrl" type="hidden" value="" />
        <input id="cancelUrl" name="cancelUrl" type="hidden" value="" />
      </form>
      <form id="pno" name="pno">
        <input id="avsName" name="avsName" type="hidden" value="" />
        <input id="avsAddress1" name="avsAddress1" type="hidden" value="" />
        <input id="avsAddress2" name="avsAddress2" type="hidden" value="" />
        <input id="avsCity" name="avsCity" type="hidden" value="" />
        <input id="avsState" name="avsState" type="hidden" value="" />
        <input id="avsZip" name="avsZip" type="hidden" value="" />
        <input id="avsCountryCode" name="avsCountryCode" type="hidden" value="" />
        <input id="avsPhone" name="avsPhone" type="hidden" value="" />
        <input id="ecpCheckRT" name="ecpCheckRT" type="hidden" value="" />
        <input id="ecpBankAcctType" name="ecpBankAcctType" type="hidden" value="" />
        <input id="ecpCheckDDA" name="ecpCheckDDA" type="hidden" value="" />
        <input id="comments" name="comments" type="hidden" value="" />
        <input id="amount" name="amount" type="hidden" value="" />
        <input id="orderID" name="orderID" type="hidden" value="" />
        <input id="retryTrace" name="retryTrace" type="hidden" value="" />
        <input id="customerEmail" name="customerEmail" type="hidden" value="" />
        <input id="priorAuthCd" name="priorAuthCd" type="hidden" value="" />
        <input id="merchantID" name="merchantID" type="hidden" value="" />
        <input id="orbitalConnectionUsername" name="orbitalConnectionUsername" type="hidden" value="" />
        <input id="orbitalConnectionPassword" name="orbitalConnectionPassword" type="hidden" value="" />
        <input id="switchSoloIssueNum" name="switchSoloIssueNum" type="hidden" value="" />
        <input id="switchSoloCardStartDate" name="switchSoloCardStartDate" type="hidden" value="" />
        <input id="authenticationECIInd" name="authenticationECIInd" type="hidden" value="" />
      </form>
      <div
        id="main-content"
        className={`${s21csamycsaach.mainContent} ${s21csamycsaach.mainContentFont} ${s21csamycsaach.bootstrapWrapper} `}
        style={{
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <div id="page-wrapper" className={s21csamycsaach.body}>
          <div className="row" style={{ width: "95%" }}>
            <form id="ach" name="ach" method="post" target="_self">
              <input id="appToken" name="appToken" type="hidden" value={appTokenName} />
              <input id="otherAmount" name="userNotherAmountame" type="hidden" value="" />
              <input id="tceppsEncryptedResponse" name="tceppsEncryptedResponse" type="hidden" value={tceppsState.encryptedRequest} />
              <input
                id="tceppsEncryptedResponseKey"
                name="tceppsEncryptedResponseKey"
                type="hidden"
                value={tceppsState.encryptedRequestKey}
              />
              <input id="tceppsEncryptedRequest" name="tceppsEncryptedRequest" type="hidden" value={tceppsState.encryptedRequest} />

              <div className="row" style={{ marginTop: "20px" }}>
                <div className="col-lg-offset-1 col-lg-5 col-md-offset-1 col-md-5 col-sm-offset-1 col-sm-5">
                  {processing && (
                    <p id="processing" style={{ color: "blue" }}>
                      Processing...
                    </p>
                  )}
                  {showErrorMessage && errorMessage && (
                    <p id="processing" style={{ color: "red" }}>
                      {errorMessage}
                    </p>
                  )}
                </div>
              </div>

              <div className={`row ${s21csamycsaach.formContainerRow}`}>
                <span id="durationMessage" style={{ fontSize: "13px" }}>
                  {durationMessage}
                </span>

                <div className={`row ${s21csamycsaach.formTitle}`}>
                  <div>Enter your bank Account and Routing number</div>
                </div>

                <div style={{ marginBottom: "0" }}>
                  <table id="tbl" className={s21csamycsaach.tbl}>
                    <tbody>
                      <tr>
                        <td className={s21csamycsaach.tdLbl}>
                          <span className={s21csamycsaach.req}>*</span>Bank Account Number
                        </td>
                        <td className="newAct">
                          <input
                            type="text"
                            name="ecpCheckDDA"
                            id="ecpCheckDDA"
                            size={18}
                            maxLength={17}
                            tabIndex={1}
                            value={ecpCheckDDA}
                            disabled={ecpCheckDDADisabled}
                            ref={ecpCheckDDARef}
                            onChange={(event) => onChangeHandler("ecpCheckDDA", event)}
                            onBlur={(event) => onBlurHandler("ecpCheckDDA", event)}
                          />
                          <span className={s21csamycsaach.errMsg}>
                            <br />
                            {ecpCheckDDAMsg && <span style={{ color: "red" }}>{ecpCheckDDAMsg}</span>}
                          </span>
                        </td>
                      </tr>

                      <tr>
                        <td className={s21csamycsaach.tdLbl} style={{ whiteSpace: "nowrap" }}>
                          <span className={s21csamycsaach.req}>*</span>Re-enter Bank Account Number
                        </td>
                        <td className="newAct">
                          <input
                            id="ecpCheckDDAConfirm"
                            name="ecpCheckDDAConfirm"
                            type="text"
                            size={18}
                            maxLength={17}
                            tabIndex={2}
                            value={ecpCheckDDAConfirm}
                            disabled={ecpCheckDDAConfirmDisabled}
                            ref={ecpCheckDDAConfirmRef}
                            onChange={(event) => onChangeHandler("ecpCheckDDAConfirm", event)}
                            onBlur={(event) => onBlurHandler("ecpCheckDDAConfirm", event)}
                            title="right click/paste is disabled"
                            onContextMenuCapture={(event) => tceppsResponseErrorUiCopyPaste(event)}
                            onPasteCapture={(event) => tceppsResponseErrorUiCopyPaste(event)}
                            onDropCapture={(event) => tceppsResponseErrorUiCopyPaste(event)}
                            autoComplete="off"
                            onCopyCapture={(event) => tceppsResponseErrorUiCopyPaste(event)}
                            onCutCapture={(event) => tceppsResponseErrorUiCopyPaste(event)}
                            onDragCapture={(event) => tceppsResponseErrorUiCopyPaste(event)}
                            onKeyDown={onKeyDownHandler}
                          />
                          <span className={s21csamycsaach.errMsg}>
                            <br />
                            {ecpCheckDDAConfirmMsg && <span style={{ color: "red" }}>{ecpCheckDDAConfirmMsg}</span>}
                          </span>
                        </td>
                      </tr>

                      <tr>
                        <td className={s21csamycsaach.tdLbl}>
                          <span className={s21csamycsaach.req}>*</span>Routing Number
                        </td>
                        <td>
                          <input
                            id="ecpCheckRT"
                            name="ecpCheckRT"
                            type="text"
                            size={10}
                            maxLength={9}
                            tabIndex={3}
                            value={ecpCheckRT}
                            disabled={ecpCheckRTDisabled}
                            ref={ecpCheckRTRef}
                            onChange={(event) => onChangeHandler("ecpCheckRT", event)}
                            onBlur={(event) => onBlurHandler("ecpCheckRT", event)}
                          />
                          <span className={s21csamycsaach.errMsg}>
                            <br />
                            {ecpCheckRTMsg && <span style={{ color: "red" }}>{ecpCheckRTMsg}</span>}
                          </span>
                        </td>
                      </tr>

                      <tr>
                        <td className={s21csamycsaach.tdLbl}>
                          <span className={s21csamycsaach.req}>*</span>Phone Number
                        </td>
                        <td>
                          <input
                            id="avsPhone"
                            name="avsPhone"
                            type="text"
                            size={13}
                            maxLength={12}
                            tabIndex={4}
                            value={avsPhone}
                            disabled={avsPhoneDisabled}
                            className={s21csamycsaach.interactivePlaceholder}
                            ref={avsPhoneRef}
                            placeholder="123-456-7890"
                            onChange={(event) => onChangeHandler("avsPhone", event)}
                            onBlur={(event) => onBlurHandler("avsPhone", event)}
                          />
                          <span className={s21csamycsaach.errMsg}>
                            <br />
                            {avsPhoneMsg && <span style={{ color: "red" }}>{avsPhoneMsg}</span>}
                          </span>
                        </td>
                      </tr>

                      <tr>
                        <td className={s21csamycsaach.tdLbl}>Amount</td>
                        <td>{formatedAmountRef.current}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="row" style={{ marginTop: "5px" }}>
                  <div id="vpos_telecheck_disclosure_prearranged_personal" className="vpos-telecheck-disclosure-section">
                    <div
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        padding: "0",
                        marginTop: "0",
                        marginBottom: "0",
                        textAlign: "justify",
                      }}
                    >
                      <label
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "10px",
                          fontFamily: "sans-serif",
                        }}
                      >
                        <input
                          id="agreement"
                          name="agreement"
                          type="checkbox"
                          tabIndex={5}
                          checked={agreementCheck}
                          disabled={agreementCheckDisabled}
                          ref={agreementCheckRef}
                          className="telecheck-disclosure-checkbox"
                          onChange={(event) => onChangeHandler("agreement", event)}
                          style={{ marginTop: "3px" }}
                        />

                        <strong style={{ fontWeight: "bold", color: "#333", fontSize: "14px", lineHeight: "1.2" }}>
                          By checking the box next to "I Agree" and then clicking "Submit" the party listed under "Customer Name" above
                          ("Customer") hereby: (i) authorized Canon U.S.A., Inc. ("Company") to initiate debit entries (withdrawals) in the
                          Amount(s) listed above, by electronic funds transfer (ETF) through automatic clearing house [ACH] processes, to
                          Customer's account listed above at Customer's bank, for payment of goods and/or services; (ii) authorizes the
                          Customer's bank to debit such Amount(s) to such account (iii) agrees that the terms and condition of the
                          Customer's separate agreement with Company concerning the method and timing of the payment are amended to the
                          extent necessary to permit the method and timing of the payment provided above; (iv)agrees that company is not
                          responsible for any loss which may arise by reason of an error mistake or fraud in the information provided by
                          Customer; and (v) consents to the use of electronic signature process for the for foregoing authorizations and
                          agreement. If Customer does not agree to the terms set forth in (i) through (v) above, then Customer should not
                          check the box next to "I Agree" and Customer will not be able to click "Submit".
                        </strong>
                      </label>
                    </div>
                    <p></p>
                  </div>
                </div>

                <div id="tr_btn" className="row">
                  <input
                    type="button"
                    id="submitTransaction"
                    value="Submit Payment"
                    className={!submitButtonEnable ? s21csamycsaach.btnDisable : s21csamycsaach.btnRed}
                    tabIndex={6}
                    onClick={(event) => onClickHandler(event)}
                    disabled={!submitButtonEnable}
                  />

                  <input
                    type="button"
                    id="cancel"
                    value="Clear"
                    tabIndex={7}
                    className={`${!clickSubmit ? s21csamycsaach.btnRed : s21csamycsaach.btnDisable} ${s21csamycsaach.btnClearSpacing}`}
                    onClick={(event) => onClickHandler(event)}
                    disabled={clickSubmit}
                  />
                </div>
              </div>

              <dialog id="confirmCancelDialog" style={{ width: "400", height: "52" }}>
                <div
                  id="confirmCancel"
                  style={{ verticalAlign: "middle", width: "400px", height: "52px", justifyContent: "center", alignItems: "center" }}
                >
                  <p>Do you want to cancel your transaction? Please confirm.</p>
                  <p style={{ textAlign: "center" }}>
                    <input type="button" id="cancelOrder" value="Yes" tabIndex={1} onClick={(event) => onClickHandler(event)} />
                    {"  "}
                    <input type="button" id="closeConfirmCancel" value="No" tabIndex={2} onClick={(event) => onClickHandler(event)} />
                  </p>
                </div>
              </dialog>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
